<template>
  <div id="noticias">
    <div id="desta">
        <div class="noti" v-for="dest in destacados" :key="dest.id" :class="dest.etiqueta">
            <div class="top">
                <p class="eti">{{ dest.etiqueta }}</p>
                <p class="fecha">{{ dest.fecha }}</p>
            </div>
            <h3 class="titu">{{ dest.titulo }}</h3>
            <img class="foto" :src="getImgUrl(dest.foto)" :alt="dest.titulo">
            <div class="notiTex">
                <p class="tex" :class="{ dest: destacados }" ref="el">{{ textoSin() }}</p>
            </div>
        </div>
    </div>
    <div id="notis">
        <div class="noti" v-for="noti in notis" :key="noti.id" :class="noti.etiqueta">
            <div class="top">
                <p class="eti">{{ noti.etiqueta }}</p>
                <p class="fecha">{{ noti.fecha }}</p>
            </div>
            <h5 class="titu">{{ noti.titulo }}</h5>
            <img class="foto" :src="getImgUrl(noti.foto)" :alt="noti.titulo">
            <div class="notiTex">
                <p class="tex" :class="{ not: notis }" ref="eln">{{ textoSinN() }}</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        noticias: {
            type: Array,
            default: () => []
        },
        cambia: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            destacados: [],
            notis: [],
            arrayElegido: [],
            optionSel: 'all'
        }
    },
    mounted(){
        this.destaca()
    },
    methods: {
        // elegir(eti){
        //     console.log('elegir etiqueta', eti)
        //     this.optionSel = eti
        //     if(this.cambia == eti){
        //         this.noticias.forEach((d) => {
        //             if(d.etiqueta == eti){
        //                 this.arrayElegido.push(d)
        //             }
        //         })
        //     } else if(this.cambia == 'all') {
        //         this.arrayElegido = this.notis
        //     }
        // },
        // muestra(eti){
        //     setTimeout(() => {
        //         if(this.classList.includes(eti)){
        //             return this.$refs.ver
        //         }
        //     }, 300);
        // },
        destaca(){
            let desta = []
            let not = []
            this.noticias.forEach((d) => {
                if(d.destacado == 'si'){
                    desta.push(d)
                } else {
                    not.push(d)
                }
            })
            this.destacados = desta
            this.notis = not
        },
        getImgUrl(img) {
            if(img !== undefined){
                let images = require.context('../assets/noti/', false, /\.jpg$/)
            return images('./' + img + '.jpg')
            }
        },
        textoSin(){
            setTimeout(() => {
                let pTexto = this.$refs.el;
                for (let i = 0; i < pTexto.length; i++) {
                    pTexto[i].innerHTML = this.destacados[i].texto
                }
            }, 300);
        },
        textoSinN(){
            setTimeout(() => {
                let pTexto = this.$refs.eln;
                for (let i = 0; i < pTexto.length; i++) {
                    pTexto[i].innerHTML = this.notis[i].texto
                }
            }, 300);
        }
    }
}
</script>

<style lang="scss" scoped>
#noticias{
    width: 100%;
    max-width: 1000px;
    margin: 50px auto;

    #desta, #notis {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        gap: 50px;

        .top{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            margin: 10px auto 30px;
            .eti{
                text-transform: uppercase;
                color: var(--medium-gray);
                padding: 5px 10px;
                border: 1px solid var(--medium-gray);
                margin: 0 auto 10px 0;
                font-size: .8rem;
                width: fit-content;
            }
            .fecha{
                color: var(--medium-gray);
                padding: 5px 10px;
                margin: 0 0 10px auto;
                font-size: .9rem;
                text-align: right;
                width: fit-content;
                position: relative;
                &:after {
                    content: '';
                    width: 0;
                    height: 0;
                    position: absolute;
                    top: 9px;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-right: 5px solid var(--medium-gray);
                    // border-left: 5px solid transparent;
                    right: 0px;
                }
            }
        }

        .foto{
            width: 100%;
            margin: 30px auto 10px;
        }
        .noti {
            width: 90%;
            margin: auto;
            border-bottom: 2px solid var(--sate);
            position: relative;

            &:before{
                content: '';
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 2px solid var(--sate);
                background-color: var(--white);
                position: absolute;
                left: 50%;
                bottom: -15.5px;
                transform: translateX(-50%);
            }
            &:after{
                content: '';
                width: 10px;
                height: 10px;
                position: absolute;
                left: 50%;
                bottom: -6px;
                background-color: var(--sate);
                transform: translateX(-50%);
                border-radius: 50%;
                // border: 2px solid var(--black);
            }
            &:last-child{
                border-bottom: 2px solid var(--white);
                &:after, &:before{
                    // display: none;
                }
            }

            .titu{
                @media screen and (max-width: 600px) {
                    width: 95%;
                    font-size: var(--t4);
                    text-align: left;
                }
            }

            .notiTex{
                margin: 20px auto 50px;
                .tex{
                    // width: 90%;
                    margin: auto;
                }
            }
        }
    }
    #notis{
        // display: flex;
        margin-top: 100px;
        flex-flow: row wrap;
        // justify-content: flex-start;
        // align-items: flex-start;
        // align-content: flex-start;
        gap: 50px 20px;

        // .foto{
        //     width: 100%;
        // }
        @media screen and (max-width: 600px) {
            flex-flow: column nowrap;
        }
        
        .noti{
            width: 40%;
            min-height: 250px;
            margin-top: 0;
            display: unset;
            padding-top: 20px;
            border-top: 2px solid var(--sate);
            border-bottom: 2px solid var(--white);

            // margin: auto;
            &:before{
                content: '';
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: var(--white);
                position: absolute;
                left: 50%;
                top: -12px;
                transform: translateX(-50%);
            }
            &:after{
                content: '';
                width: 7px;
                height: 7px;
                position: absolute;
                left: 50%;
                top: -4px;
                background-color: var(--sate);
                transform: translateX(-50%);
                border-radius: 50%;
                // border: 2px solid var(--black);
            }
            .titu{
                text-align: left;
                margin: 20px auto 0;
            }
            .notiTex{
                margin: 20px auto 50px;
            }
            @media screen and (max-width: 600px) {
                width: 90%;
            }
        }
    }

}

</style>